import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CalendarDay, CalendarDayResponse } from '../interfaces/calendar.interface';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor(
    private http: HttpClient
  ) { }

  getCalendar(startDate: string, endDate: string) {
    return this.http.get<any>(`${environment.apiUrl}/calendar?start_date=${startDate}&end_date=${endDate}`);
  }

  updateCalendarDay(data: CalendarDayResponse) {
      return this.http.put<any>(`${environment.apiUrl}/calendar`, [data]);
  }

}
